;(function($){

	"use strict";

	$(document).ready(function(){

		/* ------------------------------------------------
				magnificPopup
		------------------------------------------------ */

			$('.video_btn').magnificPopup({
				
				disableOn: 700,
				type: 'iframe',
				mainClass: 'mfp-fade',
				removalDelay: 160,
				preloader: false,
				fixedContentPos: false

			});

        /* ------------------------------------------------
				End of magnificPopup
		------------------------------------------------ */

		/* ------------------------------------------------
				owlCarousel
		------------------------------------------------ */

			if($('.about_slider').length){

				$('.about_slider').owlCarousel({
				    loop:true,
				    nav:true,
					navText: [ '', '' ],
				    items:1
				})

				
				$('.about_slider').on('resized.owl.carousel', function(event) {
				    
				    $.fn.matchHeight._update()

				});

			}



        /* ------------------------------------------------
				End of owlCarousel
		------------------------------------------------ */

	});

	$(window).load(function(){

		/* ------------------------------------------------
	    	Parallax
		------------------------------------------------ */

			if($(".blackout[class*='bg'],.blackout2[class*='bg'], .cstheme_parallax").length){

				$(".blackout[class*='bg'],.blackout2[class*='bg'], .cstheme_parallax").each(function(){

					$(this).parallax("50%", 0.2);

				});

			}
		/* ------------------------------------------------
		    End Parallax
		------------------------------------------------ */

	});

})(jQuery);